import React from "react"
import BlogSettingFormItem from "./BlogSettingFormItem"
import {Link} from "react-router-dom"

export default function() {
  return (
    <BlogSettingFormItem title='데이터 관리'>
      <Link to="/setting/blog/data" className="box_blog link_detail">
        <strong className="txt_data">데이터 관리하기</strong>
        블로그의 모든 데이터를 삭제하거나 이 블로그를 폐쇄합니다.
        <span className="ico_blog"/>
      </Link>
    </BlogSettingFormItem>
  )
}
